var map = {
	"./arbre_1.png": "074e",
	"./arbre_1_ombre.png": "4132",
	"./arbre_2.png": "ce93",
	"./arbre_2_ombre.png": "2574",
	"./arbre_3.png": "0490",
	"./arbre_3_ombre.png": "0ab3",
	"./arbre_4.png": "92d8",
	"./arbre_4_ombre.png": "2f53",
	"./arbre_5.png": "b41a",
	"./arbre_5_ombre.png": "4a49",
	"./daniel.png": "1bf2",
	"./ombre.png": "94ad",
	"./silhouette.png": "b2a0",
	"./sun.png": "24ed"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4a6d";